<template>
    <div class="payment__error">
        <no-agents-error v-if="paymentError.code === AccountError.AgentNotFound"/>
    </div>
</template>

<script setup lang="ts">
import {PropType} from "vue";
import PurchaseOperation from "@models/operations/PurchaseOperation";
import NoAgentsError from "@/targets/light/views/auth-error/components/NoAgentsError.vue";
import LightPaymentPidResponseError from "@models/responses/light-payment-pid/LightPaymentPidResponseError";
//@ts-ignore
import AppController from "@target/components/App/ts/AppController";
import {AccountError} from "@enums/ServerErrorCodes";

const props = defineProps({
    payment: {
        type: Object as PropType<PurchaseOperation>,
        required: true
    },
});

const paymentError: LightPaymentPidResponseError = AppController.getInstance().paymentService.paymentError;
</script>

<style src="../index.scss"></style>
<style lang="scss">
.payment__error {
    .info-block {
        margin-top: 56px;
    }
}
</style>
